import React, { memo } from 'react'

import { func, number, objectOf, string } from 'prop-types'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { VIEWER_SIDEBAR_TAB } from 'Pods/ThreeDStudio/Store/constants'

import Chip from './Components/Chip/Chip'

const VARIATION_CATEGORIES = [
  VIEWER_SIDEBAR_TAB.REMESH,
  VIEWER_SIDEBAR_TAB.TEXTURE,
  VIEWER_SIDEBAR_TAB.SEGMENT,
  VIEWER_SIDEBAR_TAB.ANIMATE,
  VIEWER_SIDEBAR_TAB.RENDER,
]

function CategoryFilters({
  allCount,
  countByCategory,
  selectedCategory = null,
  onSelect: handleSelect,
}) {
  const t = useTranslation()

  return (
    <div
      className="variations-tab__filters"
      role="group"
      aria-label={t('viewerSidebar.enhance.variations.filters.label')}
    >
      <Chip
        label={t('viewerSidebar.enhance.variations.filters.all')}
        count={allCount}
        isActive={selectedCategory == null}
        onClick={() => handleSelect(null)}
      />
      {VARIATION_CATEGORIES.map(category => (
        <Chip
          key={category}
          label={t(`viewerSidebar.nav.${category}`)}
          count={countByCategory[category]}
          isActive={selectedCategory === category}
          onClick={() => handleSelect(category)}
        />
      ))}
    </div>
  )
}

CategoryFilters.propTypes = {
  allCount: number.isRequired,
  countByCategory: objectOf(number).isRequired,
  selectedCategory: string,
  onSelect: func.isRequired,
}

export default memo(CategoryFilters)
